import { Component, ElementRef, HostListener, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MdbChartDirective } from 'mdb-angular-ui-kit/charts';
import * as moment from 'moment';
import { ComponentBase, RentalKPI } from 't4core';
import { interval, Subscription, timer } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
    selector: 't4-kpi',
    templateUrl: './t4kpi.html',
    styleUrls: ['./t4kpi.css'],
})
export class T4KPI extends ComponentBase implements OnInit, OnDestroy, OnChanges {
   
    @Input() title: string = "";
    @Input() type: string = "numeric";
  @Input() invert: boolean = false;

  @Input() refreshRate: number = 0;

    @Input() fromDate: moment.Moment = moment().startOf('month');
    @Input() toDate: moment.Moment = moment().endOf('month');
    @Input() kpiId: string = "";
  @Input() database: string = "";
  @Input() service: string = "";

    @Input() label1: string = "";
    @Input() label2: string = "";

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.flexFont();
    }

    @ViewChild("Panel", {static: true}) public panel: ElementRef;
    public autoFontSize: string = 'auto';

    @Input() public Value: number = 0;
    @Input() public RelatedValue: number = 0;
    @Input() public Delta: number = 0;

  private timerSub: Subscription;

    public get InterpretationIsPositive(): boolean {
        var ret = false;
        if (!this.invert && this.Delta > 0) ret = true;
        if (this.invert && this.Delta < 0) ret = true;

        return ret;
    }

    public get InterpretationIsNegative(): boolean {
        var ret = false;
        if (!this.invert && this.Delta < 0) ret = true;
        if (this.invert && this.Delta > 0) ret = true;

        return ret;
    }

  @Input() public isLoading: boolean = false;

  @ViewChild(MdbChartDirective, {static: false}) chartPercentage !: MdbChartDirective;
    public percentageData = [{
        data: [50, 50],
        backgroundColor: ["#8fd0b9", "#f2a79e"],
        hoverBackgroundColor: ["#8fd0b9", "#f2a79e"]
    },
    {
        data: [50, 50],
        backgroundColor: ["#8fd0b9", "#f2a79e"],
        hoverBackgroundColor: ["#8fd0b9", "#f2a79e"]
    }];
    public percentageOptions = {
        responsive: true,
    };
    public percentageColors = ["#8fd0b9", "#f2a79e"];
    public chartLabels = [this.label1, this.label2];

    constructor() {
        super();
    }

    private isInitializing: boolean = true;
    public async ngOnInit() {
        this.flexFont();
        await this.loadData();

      if(this.timerSub) this.timerSub.unsubscribe();
        if (this.refreshRate > 10000) { 
          this.timerSub = timer(this.refreshRate, this.refreshRate).subscribe(x => this.loadData());
        }

        this.isInitializing = false;
  }

  private awaitingUpdate: boolean = false;
  public ngOnChanges(changes: SimpleChanges) {
    if (this.isInitializing) return;
    if (changes.fromDate || changes.toDate) {
      this.awaitingUpdate = true;
      setTimeout(async () => {
        await this.loadData();
        this.awaitingUpdate = false;
      }, 250);
    }
  }

  public async ngOnDestroy() {
    if (this.timerSub) this.timerSub.unsubscribe();
  }

    private async loadData() {
      if (!this.kpiId && !this.service) return;

        this.isLoading = true;
        var val: RentalKPI;
        if(this.database == "TurboOrder")
            val = await this.Api.get<RentalKPI>("TurboOrder/GetKPI", { kpiId: this.kpiId, from: this.fromDate, to: this.toDate })
        else if (this.service.indexOf("RentalObject") >= 0 || this.service.includes("Service"))
          val = await this.Api.get<RentalKPI>(this.service, { from: this.fromDate, to: this.toDate })
        else
            val = await this.Api.get<RentalKPI>("OneWay/GetRentalKPI", { kpiId: this.kpiId, from: this.fromDate, to: this.toDate })

        this.Value = val.Value;
        this.RelatedValue = val.RelatedValue;
        this.Delta = val.Delta;

        if (this.chartPercentage) {
            this.percentageData[0].data[0] = Math.round(val.Value * 100);
            this.percentageData[0].data[1] = Math.round((1 - val.Value) * 100);
            this.percentageData[1].data[0] = Math.round(val.RelatedValue * 100);
            this.percentageData[1].data[1] = Math.round((1 - val.RelatedValue) * 100);
            this.chartLabels = [this.label1, this.label2];

            this.chartPercentage.update();
        }

        this.isLoading = false;
    }


    public flexFont() {
        var relFontsize = this.panel.nativeElement.offsetWidth * 0.18;
        this.autoFontSize = relFontsize + 'px';
    };
}
